(function () {
  // Shared guard: if product-slider.js is ALSO loaded on this same page,
  // only one wishlist click handler should ever bind — otherwise a single
  // click fires twice and cancels itself out.
  if (window.__ahfWishlistClickBound) return;
  window.__ahfWishlistClickBound = true;

  function syncButton(btn) {
    const id = btn.dataset.productId;
    if (!id || !window.AhfWishlist) return;
    const saved = window.AhfWishlist.isSaved(id);
    btn.classList.toggle('is-active', saved);
    btn.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function syncAll() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(syncButton);
  }

  document.addEventListener(
    'click',
    (event) => {
      const btn = event.target.closest('[data-wishlist-toggle]');
      if (!btn || !window.AhfWishlist) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      const product = {
        id: btn.dataset.productId,
        handle: btn.dataset.productHandle,
        title: btn.dataset.productTitle,
        image: btn.dataset.productImage,
        price: btn.dataset.productPrice,
        url: btn.dataset.productUrl,
        variantId: btn.dataset.variantId,
      };

      const { saved } = window.AhfWishlist.toggle(product);
      btn.classList.toggle('is-active', saved);
      btn.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Add to wishlist');
    },
    true
  ); // capture phase — must intercept before the zoom-open handler on the ancestor slide fires;
     // stopPropagation() in the old bubble-phase version ran too late to stop it.

  document.addEventListener('wishlist:change', syncAll);

  if (window.AhfWishlist) {
    syncAll();
  } else {
    document.addEventListener('DOMContentLoaded', syncAll);
  }
})();